


import React, { useEffect, useState, useRef,useMemo, useCallback, useContext } from "react";
import { GameConfig, DEFAULT_GAME_CONFIG,OPTION_LABELS } from "./game";
import { activityUpdate, createGamePlayHistory } from '../../../../../src/utils/gameApplication/gameActivityService';
import { getAverageScore } from "utils/gameApplication/gamePlayService";
import AOS from "aos";
import { ScoreContext } from "../GamePreview";
import { updateWeHaveChooseBlock } from "../common";
// import { getAverageScore } from "utils/gameApplication/gamePlayService";
// Audio context singleton
let audioCtx: AudioContext | null = null;
let audioUnlocked = false;

function unlockAudio() {
  if (audioUnlocked) return;
  try {
    // Create context inside gesture handler for Safari
    if (!audioCtx) {
      audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    // Safari requires resume in gesture - must await
    audioCtx.resume().then(() => {
      // Play a silent oscillator to fully unlock on Safari
      const osc = audioCtx!.createOscillator();
      const gain = audioCtx!.createGain();
      gain.gain.value = 0.0001;
      osc.connect(gain);
      gain.connect(audioCtx!.destination);
      osc.start();
      osc.stop(audioCtx!.currentTime + 0.01);
      audioUnlocked = true;
    }).catch(() => {
      // Fallback if resume fails
      audioUnlocked = true;
    });
  } catch (e) {
    // Audio is optional
  }
}

function playTone(kind: string = "tap") {
  if (!audioUnlocked || !audioCtx) return;
  if (audioCtx.state === 'suspended') {
    audioCtx.resume();
  }

  try {
    const now = audioCtx.currentTime;
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.connect(gain);
    gain.connect(audioCtx.destination);

    if (kind === "whoosh") {
      osc.type = "triangle";
      osc.frequency.setValueAtTime(420, now);
      osc.frequency.exponentialRampToValueAtTime(120, now + 0.18);
      gain.gain.setValueAtTime(0.04, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.20);
      osc.start(now);
      osc.stop(now + 0.22);
    } else if (kind === "hover") {
      osc.type = "sine";
      osc.frequency.setValueAtTime(1600, now);
      gain.gain.setValueAtTime(0.02, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.05);
      osc.start(now);
      osc.stop(now + 0.06);
    } else if (kind === "good") {
      osc.type = "sine";
      osc.frequency.setValueAtTime(520, now);
      osc.frequency.exponentialRampToValueAtTime(880, now + 0.10);
      gain.gain.setValueAtTime(0.05, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.18);
      osc.start(now);
      osc.stop(now + 0.2);
    } else if (kind === "bad") {
      osc.type = "sawtooth";
      osc.frequency.setValueAtTime(180, now);
      osc.frequency.exponentialRampToValueAtTime(100, now + 0.15);
      gain.gain.setValueAtTime(0.04, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.18);
      osc.start(now);
      osc.stop(now + 0.2);
    } else if (kind === "fanfare") {
      const notes = [523.25, 659.25, 783.99, 1046.50];
      notes.forEach((freq, i) => {
        const o = audioCtx!.createOscillator();
        const g = audioCtx!.createGain();
        o.type = "triangle";
        o.frequency.setValueAtTime(freq, now + i * 0.1);
        g.gain.setValueAtTime(0.06, now + i * 0.1);
        g.gain.exponentialRampToValueAtTime(0.001, now + i * 0.1 + 0.35);
        o.connect(g);
        g.connect(audioCtx!.destination);
        o.start(now + i * 0.1);
        o.stop(now + i * 0.1 + 0.4);
      });
      return;
    } else if (kind === "complete") {
      osc.type = "sine";
      osc.frequency.setValueAtTime(660, now);
      osc.frequency.setValueAtTime(880, now + 0.1);
      gain.gain.setValueAtTime(0.05, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.3);
      osc.start(now);
      osc.stop(now + 0.35);
    } else if (kind === "timeout") {
      osc.type = "square";
      osc.frequency.setValueAtTime(200, now);
      osc.frequency.exponentialRampToValueAtTime(80, now + 0.15);
      gain.gain.setValueAtTime(0.05, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.2);
      osc.start(now);
      osc.stop(now + 0.22);
    } else if (kind === "tick") {
      osc.type = "sine";
      osc.frequency.setValueAtTime(1000, now);
      gain.gain.setValueAtTime(0.03, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.05);
      osc.start(now);
      osc.stop(now + 0.06);
    } else {
      // tap
      osc.type = "sine";
      osc.frequency.setValueAtTime(1200, now);
      gain.gain.setValueAtTime(0.03, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.06);
      osc.start(now);
      osc.stop(now + 0.07);
    }
  } catch (e) {
    // Audio is optional
  }
}

const WeHaveChooseMinigame = ({ 
   AssignId,
  setGameProgressData,
    gameProgressData,
seconds,
 data,type, learner_game_play_id,gameInfo,Activitydata,setActivitydata,formData,learnerPlayList,setProfile,setLearnerPlayingDetails,profile,questState,onCompleted, isAudioPaused,WeHaveChooseCompleted,setWeHaveChooseCompleted}: { 
   WeHaveChooseCompleted?:any;
   AssignId?:any;
   gameProgressData?:any;
  setGameProgressData?:any;
   seconds?:any;
  setWeHaveChooseCompleted?:any;
   data?:any;
 type?: any;
 gameInfo?:any;
  learner_game_play_id?:any;
 learnerPlayList?:any;
 formData?:any;
 setActivitydata?:any;
 Activitydata?:any;
 setProfile?:any;
 questState?:any;
 profile?:any
 setLearnerPlayingDetails?:any;
 onCompleted?: () => void;
  isAudioPaused?: boolean;


 
} = {}) => {
  const [config, setConfig] = useState<GameConfig | null>(null);

const [miniGameScore, setMiniGameScore] = useState(0);
const [prevAvgScore, setPrevAvgScore] = useState<number>(0);
  const [prevMiniGameBest, setPrevMiniGameBest] = useState(0);
const [bestScore, setBestScore] = useState(0);
const [currentGameScore, setCurrentGameScore] = useState(0); // ✅ NEW
  const [averageScore, setaverageScore] = useState(0)
const [histActivityId, setHistActivityId] = useState<string | null>(null);


  AOS.init({
    once: true, // 👈 THIS fixes hover re-trigger
  });
useEffect(() => {
  const initActivity = async () => {
    try {
            let getscoreseq: any = [];
      let updatedscore: any = [];
      if (questState[parseInt(profile?.currentQuest)] === 'Started') {
        // Remove matching object from profile?.score
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      } else if (
        questState[parseInt(profile?.currentQuest)] === 'replayallowed'
      ) {
        // Remove matching object from profile?.replayScore
        getscoreseq = profile?.replayScore?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.replayScore;
      } else {
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      }
      const foundOption = getscoreseq;

      const foundOnlyOption = getscoreseq?.choosedoption;
      let total = 0;
      const scoreArray = updatedscore;

      if (scoreArray?.length > 0) {
        // STEP 2: Apply filter with logs
        const filteredData = scoreArray?.filter((cur: any, index: number) => {
          const isValidStructure =
            cur.seqId &&
            cur.scenarioId !== undefined &&
            cur.choosedoption !== undefined;

          const isQuestMatch =
            Number(cur.quest) === Number(profile.currentQuest);

          const finalResult = isValidStructure && isQuestMatch;

          return finalResult;
        });

        // STEP 3: Reduce with logs
        total = filteredData?.reduce((sum: number, cur: any, index: number) => {
          const score = Number(cur.score || 0);

          return sum + score;
        }, 0);
      }
      const conditionTypes = ['Interaction', 'response', 'feedback'];
      const updatedata = {
        galAssignedId:AssignId,
        blockname: data?.blockChoosen,
        galAverageScore: total,
        galBlockId: data?.blockSecondaryId,
        galblockleft : data?.blockSecondaryId,
        galTimeSpent: seconds,
        gameId: learner_game_play_id
      };
      const actId1 = Activitydata;
      const datas = JSON.stringify(updatedata);

      const result = await activityUpdate(datas, actId1);

      // const galId = result?.updatedData?.galId;
      const galId = result?.updatedData?.galId;
const oldScore = result?.updatedData?.galAverageScore || 0;

if (galId) {
  setHistActivityId(galId);
  // setPrevAvgScore(Number(oldScore)); // ✅ save previous
  const previous = Number(oldScore) || 0;

setPrevAvgScore(previous);
setBestScore(previous); // store best

}


      if (galId) {
        setHistActivityId(galId); // ✅ store for later update
      }
    } catch (err) {
      console.error("Activity init failed:", err);
    }
  };

  initActivity();
}, []);

  const saveGameScoreHistory = async (score: any) => {
    try {
      const histdata = {
        histGameId: gameInfo.gameData.gameId,
        histQuestNo: profile.currentQuest,
        histBlockId: data.blockSecondaryId,
        histType: 'WehaveChoose',
        histScore: score,
        learnerid: learnerPlayList.playerId,
      };
      const stringhistdata = JSON.stringify(histdata)

      const historyResult = await createGamePlayHistory(stringhistdata);


    } catch (error) {
      console.error("Error saving game score history:", error);
    }
  };

  const getMinigameAverageScore = async () => {
    try {
      const histdata = {
        gameId: gameInfo.gameData.gameId,
        questNo: profile.currentQuest,
        blockSecondaryId: data.blockSecondaryId,
        type: 'WehaveChoose',
        // histScore: currentGameScore,
        learnerid: learnerPlayList.playerId,
        gameMode: ""
      };
      const stringhistdata = JSON.stringify(histdata)
      const historyResult = await getAverageScore(stringhistdata);
      if (historyResult?.status === "Success") {

        const score = historyResult?.maxScore || 0;

        setaverageScore(score); // update state (for UI)
        return score;
      }
       return 0;
    } catch (error) {
      console.error("Error saving game score history:", error);
       return 0;
    }
  };


  const handleMiniGameComplete = async (earned: number, max: number) => {


    // Store ONLY this game score for UI
    setCurrentGameScore(earned);
    if (earned > averageScore) {
      await saveGameScoreHistory(earned)
    }
    const latestAverageScore = await getMinigameAverageScore();
    setWeHaveChooseCompleted(true);

  
    setCurrentGameScore(earned);
    const gameId = String(learner_game_play_id);
    let scenarioId = 1;    // scenario id

    // let scenarioScores = JSON.parse(localStorage.getItem("scenarioScores")) || {};
    let getscenarioScores = gameProgressData?.scenarioScores || {};

    const questNo = data?.blockQuestNo;
    const scenarioName =
      typeof data.blockScenario === 'string'
        ? parseInt(data.blockScenario.replace(/\D/g, ''), 10)
        : data.blockScenario;
         // const scenarioName = data?.blockScenario;

    if (!getscenarioScores[questNo]) {
      getscenarioScores[questNo] = {};
    }

    let getexistingScore =
      getscenarioScores[questNo][scenarioName] || 0;


    // FIRST TIME PLAY
    if (getexistingScore === 0) {
      getscenarioScores[questNo][scenarioName] = earned;
    }
    // SECOND TIME OR MORE
    else if (earned > averageScore) {
      const difference = earned - averageScore;
      getscenarioScores[questNo][scenarioName] =
      getexistingScore + difference;
    }

    setGameProgressData((prev: any) => ({
      ...prev,
      scenarioScores: getscenarioScores,
    }));
   
    // create gameId if not exist
    // if (!scenarioScores[gameId]) {
    //   scenarioScores[gameId] = {};
    // }
    const getaveragescore = averageScore;

    // // get existing score
    // let existingScore = scenarioScores[gameId][scenarioId] || 0;
  
    // // FIRST TIME PLAY
    // if (existingScore === 0) {

    //   scenarioScores[gameId][scenarioId] = earned;

    // }
    // // SECOND TIME OR MORE
    // else if (earned > averageScore) {

    //   const difference = earned - averageScore;

    //   scenarioScores[gameId][scenarioId] = existingScore + difference;

    // }
    // // save
    // localStorage.setItem("scenarioScores", JSON.stringify(scenarioScores));

   


    const finalScore = Math.max(prevAvgScore, getaveragescore);

    setMiniGameScore(finalScore);
    setBestScore(finalScore);

    // if (!histActivityId) {
    //   console.warn("No histActivityId found");
    //   return;
    // }
    // setTimeout(() => {
      onCompleted?.();
    // }, 300);
    try {

      let finalScore = prevAvgScore;

      // only add improvement
      if (earned > prevMiniGameBest) {
        const difference = earned - prevMiniGameBest;

        finalScore = prevAvgScore + difference;

        // update best mini-game score
        setPrevMiniGameBest(earned);
      }

    
      const histData = {
        blockname: 'WehaveChoose',
        galAverageScore: finalScore,
        galBlockId: data?.blockSecondaryId,
         gameId: learner_game_play_id,
         galblockleft : data?.blockSecondaryId,
         galTimeSpent: seconds,
         galAssignedId:AssignId,

      };

      let eranedscoremin = earned;
      await activityUpdate(JSON.stringify(histData), histActivityId);
      setPrevAvgScore(finalScore);
      setBestScore(finalScore);

      const seqId = data?.blockPrimarySequence;
      const scoresearned = eranedscoremin;
      const questNo = parseInt(seqId.split(".")[0]);

      // Determine replay/first try mode
      const isReplay =
        Object.keys(questState).length > 0 &&
        questState[profile?.currentQuest] === "replayallowed";
        const scenarioIds =
          typeof data.blockScenario === 'string'
            ? parseInt(data.blockScenario.replace(/\D/g, ''), 10)
            : data.blockScenario;
            
      // ✅ Update score or replayScore safely
      setProfile((prev: any) => {
        const targetList = isReplay ? prev.replayScore : prev.score;
        const idx = targetList.findIndex((i: any) => i.seqId === seqId);
        const updatedList = [...targetList];
        const numericScore = Number(scoresearned || 0);
      
        if (idx !== -1) {
          // Update existing score safely
          updatedList[idx] = {
            ...updatedList[idx],
            // score: numericScore,
            score: latestAverageScore,
            choosedoption: "",
            quest: questNo,
            scoreEarnedDate: "",
             scenarioId: scenarioIds,
          };
        } else {
          // Add new score entry
          updatedList.push({
            seqId,
            // score: numericScore,
            score: latestAverageScore,
            choosedoption: "",
            quest: questNo,
            scoreEarnedDate: "",
             scenarioId: scenarioIds,
          });
          // ✅ Only push first try to learnerPlayingDetails
          // if (!isReplay) {
          //   setLearnerPlayingDetails((prevPlay: any) => ({
          //     ...prevPlay,
          //     firstTryScore: [
          //       ...prevPlay.firstTryScore,
          //       { seqId, quest: questNo, score: latestAverageScore },
          //     ],
          //   }));
          // }
          if (!isReplay) {
  setLearnerPlayingDetails((prevPlay: any) => {
    const alreadyExists = prevPlay.firstTryScore.some(
      (item: any) => item.seqId === seqId
    );
    if (alreadyExists) return prevPlay;

    return {
      ...prevPlay,
      firstTryScore: [
        ...prevPlay.firstTryScore,
        { seqId, quest: questNo, score: latestAverageScore },
      ],
    };
  });
}

        }

        return {
          ...prev,
          [isReplay ? "replayScore" : "score"]: updatedList,
        };
      });
   
    } catch (err) {
      console.error("Score update failed:", err);
    }
  };
const currentBlockMiniGame = useMemo(() => {
  if (!gameInfo?.ChooseMiniGame || !data?.blockId) return null;

  return gameInfo.ChooseMiniGame.find(
    (game: any) =>
      String(game.miniblockId) === String(data.blockId)
  );
}, [gameInfo, data]);


const buildGameConfigFromBlock = (miniGame: any): GameConfig => {
  if (!miniGame?.roundLogic) return DEFAULT_GAME_CONFIG;


let roundObj: any;

try {
  if (typeof miniGame.roundLogic === "string") {
    roundObj = JSON.parse(miniGame.roundLogic);
  } else {
    roundObj = miniGame.roundLogic; // already an object
  }
} catch (e) {
  console.error("Invalid roundLogic:", miniGame.roundLogic);
  return DEFAULT_GAME_CONFIG;
}

const rounds = Object.entries(roundObj).map(
  ([key, round]: any, index: number) => ({
    id: `round-${index + 1}`, // ✅ required string id

    questionText: round.questionText,
    prompt: round.prompt,

    options: Object.entries(round?.options).map(
      ([optKey, opt]: any, optIndex: number) => ({
        label: OPTION_LABELS[optIndex] || optKey, // optional safety
        text: opt.optionText,
        feedback: opt.feedback,
        rewrite: opt.guidance,
        correct: opt.correct,
      })
    ),
  })
);

  return {
    version: 1,
    title: miniGame.MiniTitle || "Mini Game",
    subtitle: miniGame.WehaveChoose || "",

    characterName: miniGame.MiniTopic,
    topicSubtitle: miniGame.MiniCharacterSubTitle2,

    rounds,

    settings: {
      timerEnabled: true,
      timePerRound: miniGame.Timerlimit || 30,

      pointsPerCorrect: miniGame.PointsPerCorrectScore || 10,

      // allowReplay: miniGame.ShowReplay === "1",
      allowReplay: String(miniGame.ShowReplay).trim() === "1",


      correctLabel: miniGame.CorrectAnswerFeedback || "Correct",
      incorrectLabel: miniGame.WrongAnswerFeedback || "Wrong",

      showAnswerGuidance: true,
      answerGuidanceHeading: miniGame?.AnswerGuide,

      congratulatoryMessages: [
        {
          minPercent: miniGame.Minlowscore || 0,
          maxPercent: miniGame.Maxlowscore || 40,
          message: miniGame.LowScoreMessage || "Keep trying",
        },
        {
          minPercent: miniGame.Minmediumscore || 41,
          maxPercent: miniGame.Maxmediumscore || 70,
          message: miniGame.MediumScoreMessage || "Good job",
        },
        {
          minPercent: miniGame.Minhighscore || 71,
          maxPercent: miniGame.Maxhighscore || 100,
          message: miniGame.highScoreMessage || "Excellent",
        },
      ],
    },
  };
};


useEffect(() => {
  if (!currentBlockMiniGame) {
    console.warn("No mini-game for block:", data?.blockId);
    return;
  }

  const config = buildGameConfigFromBlock(currentBlockMiniGame);

  setConfig(config);

}, [currentBlockMiniGame]);

 
  useEffect(() => {
    // Safari requires AudioContext creation AND resume inside direct gesture handler
    const handler = () => {
      if (audioUnlocked) return;
      try {
        // Create context inside gesture handler (required for Safari)
        if (!audioCtx) {
          audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
        }
        // Synchronous resume attempt
        audioCtx.resume().then(() => {
          // Play silent oscillator to fully unlock
          const osc = audioCtx!.createOscillator();
          const gain = audioCtx!.createGain();
          gain.gain.value = 0.0001;
          osc.connect(gain);
          gain.connect(audioCtx!.destination);
          osc.start();
          osc.stop(audioCtx!.currentTime + 0.01);
          audioUnlocked = true;
        }).catch(() => {
          audioUnlocked = true;
        });
      } catch (e) {
        // Audio is optional
      }
    };
    
    
    // Don't use { once: true } - manually track unlock state
    // Safari needs touchstart specifically
    window.addEventListener("pointerdown", handler);
    window.addEventListener("touchstart", handler);
    window.addEventListener("click", handler);
    return () => {
      window.removeEventListener("pointerdown", handler);
      window.removeEventListener("touchstart", handler);
      window.removeEventListener("click", handler);
    };
  }, []);

  if (!config) {
    return (
      <div className="min-h-screen bg-[#05060a] text-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-400 mx-auto mb-4"></div>
          <p className="text-white/70">Loading game...</p>
        </div>
      </div>
    );
  }

  return <CritiqueCoachGame config={config}  onComplete={handleMiniGameComplete}   bestScore={bestScore} currentGameScore={currentGameScore}  isTimerPaused={isAudioPaused}
  data={data} />;
};

interface CritiqueCoachGameProps {
  config: GameConfig;
   onComplete: (score: number, max: number) => void; // ✅
   bestScore: number; 
    currentGameScore: number;
     isTimerPaused?: boolean;
     data:any;
}

const CritiqueCoachGame: React.FC<CritiqueCoachGameProps> = ({ config,onComplete,bestScore, currentGameScore,isTimerPaused,data }) => {
  const [currentRound, setCurrentRound] = useState(0);
   const [attempt, setAttempt] = useState(1);
   const {setlearnerActivityrec,deviceInfo } = useContext(ScoreContext);
  const [score, setScore] = useState(0);
  const [locked, setLocked] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [timeLeft, setTimeLeft] = useState(config.settings.timePerRound);
  const [gameComplete, setGameComplete] = useState(false);
  const [showWipe, setShowWipe] = useState(false);
  const [cardAnimation, setCardAnimation] = useState<string>("");
  const cardRef = useRef<HTMLDivElement>(null);

  const round = config.rounds[currentRound];
  const maxPoints = config.rounds.length * config.settings.pointsPerCorrect;
  const currentPoints = score * config.settings.pointsPerCorrect;

  // Timer effect
  useEffect(() => {
    if (!config.settings.timerEnabled || locked || gameComplete) return;

    setTimeLeft(config.settings.timePerRound);
    const interval = setInterval(() => {
      setTimeLeft((prev:any) => {
        if (prev <= 1) {
          clearInterval(interval);
          handleTimeout();
          return 0;
        }
        if (prev <= 6) {
          playTone("tick");
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [currentRound, locked, gameComplete]);

  const handleTimeout = () => {
    if (locked) return;
    setLocked(true);
    setSelectedOption(null);
    setShowFeedback(true);
    playTone("timeout");
    setCardAnimation("shake-bad");
    setTimeout(() => setCardAnimation(""), 300);
  };

  const createSparks = (buttonEl: HTMLButtonElement | null) => {
    if (!buttonEl || !cardRef.current) return;
    const rect = buttonEl.getBoundingClientRect();
    const cardRect = cardRef.current.getBoundingClientRect();
    const x = rect.left - cardRect.left + rect.width * 0.88;
    const y = rect.top - cardRect.top + rect.height * 0.5;

    for (let i = 0; i < 12; i++) {
      const spark = document.createElement("div");
      spark.className = "spark";
      const angle = (Math.PI * 2 * i) / 12 + Math.random() * 0.35;
      const rad = 18 + Math.random() * 26;
      spark.style.left = `${x}px`;
      spark.style.top = `${y}px`;
      spark.style.setProperty("--dx", `${Math.cos(angle) * rad}px`);
      spark.style.setProperty("--dy", `${Math.sin(angle) * rad}px`);
      cardRef.current.appendChild(spark);
      setTimeout(() => spark.remove(), 620);
    }
  };

  const handleChoice = (optionIndex: number, buttonEl: HTMLButtonElement | null) => {
    if (locked) return;
    unlockAudio();
    setLocked(true);
    setSelectedOption(optionIndex);

    const option = round.options[optionIndex];
     setlearnerActivityrec((prev:any)=>
      updateWeHaveChooseBlock(
        prev,
        {
          blockId:data.blockId,
          attempt:attempt,
          selectedOption:option.label,
          selectedAnswer:option.text,
          isCorrect:option.correct,
          score:option.correct ? score + 1 :score
        },
        deviceInfo
      )
    );
    if (option.correct) {
      setScore((prev) => prev + 1);
      playTone("good");
      createSparks(buttonEl);
      setCardAnimation("pulse-good");
    } else {
      playTone("bad");
      setCardAnimation("shake-bad");
    }

    setTimeout(() => setCardAnimation(""), 350);
    setShowFeedback(true);
  };

  const handleContinue = () => {
    playTone("tap");
    setShowFeedback(false);

   if (currentRound >= config.rounds.length - 1) {
  setGameComplete(true);

  const earned = score * config.settings.pointsPerCorrect;
  const max = maxPoints;
 setlearnerActivityrec((prev:any)=>
        updateWeHaveChooseBlock(
          prev,
          {
            blockId:data.blockId,
            attempt:attempt,
            finalscoreearned:earned
          },
          deviceInfo
        )
      );
  onComplete(earned, max); // ✅ Send score up
}
 else {
      setShowWipe(true);
      playTone("whoosh");
      setTimeout(() => {
        setCurrentRound((prev) => prev + 1);
        setLocked(false);
        setSelectedOption(null);
        setShowWipe(false);
      }, 500);
    }
  };

  const handleReplay = () => {
     const newAttempts = attempt + 1;
    setAttempt(newAttempts);
    playTone("tap");
    setCurrentRound(0);
    setScore(0);
    setLocked(false);
    setShowFeedback(false);
    setSelectedOption(null);
    setGameComplete(false);
    setTimeLeft(config.settings.timePerRound);
  };

  const getCongratulatoryMessage = () => {
    const percent = (score / config.rounds.length) * 100;
    const msg = config.settings.congratulatoryMessages.find(
      (m:any) => percent >= m.minPercent && percent <= m.maxPercent
    );
    return msg?.message || "Game complete!";
  };

  const circumference = 2 * Math.PI * 18;
  const timerOffset = circumference * (1 - timeLeft / config.settings.timePerRound);
  const timerState = timeLeft <= 5 ? "danger" : timeLeft <= 10 ? "warning" : "normal";

  // Get grid style based on option count
  const getGridStyle = () => {
    const count = round?.options.length || 4;
    if (count === 2) return { gridTemplateColumns: "1fr 1fr", gridTemplateRows: "1fr" };
    if (count === 3) return { gridTemplateColumns: "repeat(3, 1fr)", gridTemplateRows: "1fr" };
    return { gridTemplateColumns: "1fr 1fr", gridTemplateRows: "1fr 1fr" };
  };

  // Use empty string as intentional blank (no fallback)
  const correctLabel = config.settings.correctLabel || "";
  const incorrectLabel = config.settings.incorrectLabel || "";

  // Completion screen is now rendered inside the main card structure below
  // This keeps the card size consistent and matches the HTML design

  const selectedOpt = selectedOption !== null ? round.options[selectedOption] : null;
  const isCorrect = selectedOpt?.correct ?? false;

  return (
    <GameContainer>
      {/* Confetti shows on completion */}
      {gameComplete && <ConfettiCanvas />}
      <div className="w-full h-full" data-aos="slide-up" data-aos-delay="200" data-aos-once="true">
      <div
        className={`card p-5 ${cardAnimation} ${gameComplete ? 'complete' : ''}`}
        ref={cardRef}
        style={gameComplete ? {
          borderColor: 'rgba(54,231,255,.5)',
          boxShadow: '0 0 60px rgba(54,231,255,.25), 0 0 120px rgba(180,107,255,.15)'
        } : undefined}
      >
        {/* Wipe transition */}
        {showWipe && (
          <div className="wipe" style={{ display: "grid" }}>
            <div className="msg">
              <div style={{ fontSize: "20px", color: "rgba(255,255,255,0.85)", fontWeight: 600, letterSpacing: "1px", marginBottom: "10px" }}>
                Next Up...
              </div>
              <div className="bar"><i></i></div>
            </div>
          </div>
        )}

        {/* Feedback overlay - only during game, not completion */}
        {showFeedback && !gameComplete && (
            <div className="fbOverlay show" data-aos="none">
            <div className={`feedback ${selectedOption === null ? "bad" : isCorrect ? "good" : "bad"}`}>
              {/* Only show fb-head if there's a label to display */}
              {selectedOption === null ? (
                // <div className="fb-head">
                //   <strong>Time's up!</strong>
                // </div>
  //                 <div
  //   className="fb-head"
  //   style={{
  //     fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
  //     lineHeight: "1.5",
  //     margin: 0,
  //   }}
  // >
  //   <strong>Time's up!</strong>
  // </div>

//   <div
//   className="fb-head"
//   style={{
//     fontSize:
//       window.devicePixelRatio <= 1
//         ? "50px"
//         : window.devicePixelRatio <= 1.5
//         ? "15px"
//         : "16px",
//     lineHeight: "1.5",
//     margin: 0,
//   }}
// >
//   <strong>Time's up!</strong>
// </div>

<div className="fb-head">
  <strong
    style={{
      fontSize: "20px",
      lineHeight: "1.5",
    }}
  >
    Time's up!
  </strong>
</div>
              ) : (isCorrect ? correctLabel : incorrectLabel) ? (
                // <div className="fb-head">
                //   <strong>{isCorrect ? correctLabel : incorrectLabel}</strong>
                // </div>

  //               <div
  //   className="fb-head"
  //  style={{
  //   fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
  //   lineHeight: "1.5",
  //   margin: 0,
  // }}
  // >

  <div
  className="fb-head"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
    {/* <strong
     style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    lineHeight: "1.5",
    margin: 0,
  }}
    > */}

    <strong
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
      
      {isCorrect ? correctLabel : incorrectLabel}</strong>
  </div>
              ) : null}
              {/* <p className="fb-text">
                {selectedOption === null
                  ? "You ran out of time to make a choice."
                  : selectedOpt?.feedback}
              </p> */}

              {/* <p
  className="fb-text"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}

<p
  className="fb-text"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {selectedOption === null
    ? "You ran out of time to make a choice."
    : selectedOpt?.feedback}
</p>
              {selectedOption !== null && config.settings.showAnswerGuidance && selectedOpt?.rewrite && (
                // <p className="rewrite">
                //   <b>{config.settings.answerGuidanceHeading || "Strong Goal Example"}:</b> {selectedOpt.rewrite}
                // </p>

    //              <p
    //   className="rewrite"
    //   style={{
    //     fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    //     lineHeight: "1.5",
    //     margin: 0,
    //   }}
    // >

    <p
  className="rewrite"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
      <b>
        {config.settings.answerGuidanceHeading || "Strong Goal Example"}:
      </b>{" "}
      {selectedOpt.rewrite}
    </p>
              )}
              <div className="fbActions">
                {/* <button className="ghost" onClick={handleContinue}>Got it</button> */}
                {/* <button
  className="ghost"
  onClick={handleContinue}
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  Got it
</button> */}

<button
  className="ghost"
  onClick={handleContinue}
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  Got it
</button>
              </div>
            </div>
          </div>
        )}

        {/* Top bar - hide on completion */}
        {!gameComplete && (
          <div className="topbar">
            <div className="title">
              {/* <h1 style={{ fontWeight: 700 }}>{config.title}</h1> */}
              {/* <h1
  style={{
    fontWeight: 700,
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "20px" : "inherit",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {config.title}
</h1> */}


<h1
  style={{
    fontWeight: 700,
    fontSize:
      window.devicePixelRatio <= 1
        ? "20px"
        : window.devicePixelRatio <= 1.5
        ? "16px"
        : "20px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {config.title}
</h1>


              {/* <p>{config.subtitle}</p> */}
              {/* <p
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    // margin: 0,
    // lineHeight: "1.5",
  }}
>
  {config.subtitle}
</p> */}



<p
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "14px"
        : "16px",
    // margin: 0,
    // lineHeight: "1.5",
  }}
>
  {config.subtitle}
</p>
       </div>
            {/* <div className="badge"> */}
            {/* <div
  className="badge"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}

<div
  className="badge"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
              {/* <span className="pts"> */}
              {/* <span
  className="pts"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}

<span
  className="pts"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
                <b>{currentPoints}</b><span style={{ opacity: 0.55 }}>/</span>
                <span>{maxPoints}</span><span style={{ opacity: 0.6 }}>pts</span>
              </span>
              <span style={{ opacity: 0.25 }}>|</span>
              <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                {/* <span className="dot"></span> */}
                {/* <span
  className="dot"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    lineHeight: "1.5",
    margin: 0,
  }}
></span> */}

<span
  className="dot"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
></span>
                <span>Round {currentRound + 1}/{config.rounds.length}</span>
              </span>
            </div>
          </div>
        )}

        {/* Content */}
        <div className="content">
          {gameComplete ? (
            /* Completion content - inside same card to maintain size */
            <div className="chat-completion-enter">
              <div style={{ fontSize: "44px", marginBottom: "12px" }}>🎉</div>
              <h1 style={{ fontSize: "26px", fontWeight: 800, margin: "0 0 6px", color: "#fff", textShadow: "0 0 30px rgba(54,231,255,.4)" }}>
                Congratulations!
              </h1>
              {/* <p style={{ fontSize: "13px", color: "rgba(255,255,255,.7)", margin: "0 0 12px" }}>
                You completed the mini-game.
              </p> */}

              {/* <p
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "17px" : "14px",
    color: "rgba(255,255,255,.7)",
    margin: "0 0 12px",
    lineHeight: "1.5",
  }}
>
  You completed the mini-game.
</p> */}

<p
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "17px",
    color: "rgba(255,255,255,.7)",
    margin: "0 0 12px",
    lineHeight: "1.5",
  }}
>
  You completed the mini-game.
</p>
              <div style={{
                fontSize: "36px",
                fontWeight: 800,
                lineHeight:1.3,
                margin: "8px 0 16px",
                background: "linear-gradient(135deg, #FFD700, #FFA500, #FF8C00)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                filter: "drop-shadow(0 0 25px rgba(255,215,0,.6))",
                textShadow: "0 0 40px rgba(255,215,0,.5)",
                textRendering:"optimizeLegibility"
              }}>
                {/* {currentPoints}/{maxPoints} pts */}
                {/* {bestScore}/{maxPoints} pts */}
                {currentGameScore}/{maxPoints} pts


              </div>
              {/* <p style={{ fontSize: "13px", color: "rgba(255,255,255,.85)", margin: "0 0 20px", maxWidth: "400px", lineHeight: 1.5 }}>
                {getCongratulatoryMessage()}
              </p> */}

{/* <p
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "17px" : "14px",
    color: "rgba(255,255,255,.85)",
    margin: "0 0 20px",
    maxWidth: "100%",
    lineHeight: 1.5,
    whiteSpace: "nowrap",
  }}
> */}

<p
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "17px",
    color: "rgba(255,255,255,.85)",
    margin: "0 0 20px",
    maxWidth: "100%",
    lineHeight: 1.5,
    whiteSpace: "nowrap",
  }}
>
  {/* This needs another run! Replay to improve your goal-setting choices. */}
  {getCongratulatoryMessage()}
</p>
              {config.settings.allowReplay && (
                  <button className="replay-btn" onClick={handleReplay} >
                  🔄 Replay Mini-Game
                </button>
              )}
              {/* <p style={{ 
                fontSize: "12px", 
                color: "rgba(255,255,255,.55)", 
                marginTop: "16px",
                marginBottom: "8px",
                padding: "0 16px"
              }}>
                Or click on the <b>Next</b> button at the right to proceed to the next interaction.
              </p> */}
              {/* <p
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "17px" : "14px",
    color: "rgba(255,255,255,.55)",
    marginTop: "16px",
    marginBottom: "8px",
    padding: "0 16px",
    lineHeight: "1.5",
  }}
> */}

<p
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "17px",
    color: "rgba(255,255,255,.55)",
    marginTop: "16px",
    marginBottom: "8px",
    padding: "0 16px",
    lineHeight: "1.5",
  }}
>
  Or click on the <b>Next</b> button at the right to proceed to the next interaction.
</p>
            </div>
          ) : (
            /* Game content */
            <>
              <div className="chat">
                <div className="speaker overflow-x-hidden">
                  <div className="speaker-info">
                    <div className="avatar" aria-hidden="true"></div>
                    {config.characterName && (
                      // <div className="flex flex-col leading-5">
                      //     <div style={{ fontWeight: 600, fontSize: "13px", }}>{config.characterName}</div>
                      //     {config.topicSubtitle && (
                      //       <div style={{ fontSize: "12px", color: "var(--muted)",  }}>{config.topicSubtitle}</div>
                      //     )}
                      // </div>

                      <div className="flex flex-col leading-5">
  {/* <div
    style={{
      fontWeight: 600,
      fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "18px" : "14px",
      lineHeight: "1.5",
      margin: 0,
    }}
  > */}

  <div
  style={{
    fontWeight: 600,
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "16px"
        : "18px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
    {config.characterName}
  </div>

  {config.topicSubtitle && (
    // <div
    //   style={{
    //     fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    //     color: "var(--muted)",
    //     lineHeight: "1.5",
    //     margin: 0,
    //   }}
    // >

    <div
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    color: "var(--muted)",
    lineHeight: "1.5",
    margin: 0,
  }}
>
      {config.topicSubtitle}
    </div>
  )}
</div>
                    )}
                  </div>
                  {/* Timer */}
                  {config.settings.timerEnabled && (
                    <div className={`timer-ring ${timerState}`}>
                      <svg viewBox="0 0 44 44">
                        <circle className="timer-bg" cx="22" cy="22" r="18" fill="none" strokeWidth="3" stroke="rgba(255,255,255,.1)"></circle>
                        <circle
                          className="timer-progress"
                          cx="22"
                          cy="22"
                          r="18"
                          fill="none"
                          strokeWidth="3"
                          strokeDasharray={circumference}
                          strokeDashoffset={timerOffset}
                          strokeLinecap="round"
                          style={{
                            stroke: timerState === "danger" ? "var(--bad)" : timerState === "warning" ? "var(--gold)" : "var(--cyan)",
                            transition: "stroke-dashoffset 1s linear, stroke 0.3s ease"
                          }}
                        ></circle>
                      </svg>
                      {/* <div className="timer-text">{timeLeft}</div> */}
                      {/* <div
  className="timer-text"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}

<div
  className="timer-text"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {timeLeft}
</div>
                    </div>
                  )}
                </div>
                {/* <p className="line">{round.questionText}</p> */}

                                {/* <p
  className="prompt"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {round.questionText}
</p> */}

<p
  className="prompt"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {round.questionText}
</p>
                {/* <p className="prompt">{round.prompt}</p> */}
                {/* <p
  className="prompt"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {round.prompt}
</p> */}

<p
  className="prompt"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {round.prompt}
</p>
              </div>

              <div className="choices">
                <div id="choiceButtons" style={getGridStyle()}>
                  {round.options.map((option:any, index:any) => (
                      <div
                        data-aos="zoom-in"
                        data-aos-delay={[700, 1000, 1300, 1600][index] || 0}
                        data-aos-once="true"
                      >
                    <button
                      key={index}
                      className="btn"
                      onClick={(e) => handleChoice(index, e.currentTarget)}
                      onMouseEnter={() => playTone("hover")}
                      disabled={locked}
                      style={{
                        opacity: locked && selectedOption !== index ? 0.5 : 1,
                        borderColor: selectedOption === index
                          ? option.correct ? "rgba(76,255,176,.5)" : "rgba(255,76,123,.5)"
                          : undefined
                      }}
                    >
                      <span className="label">
                        <span className="chip">{option.label}</span>
                      </span>
                      {/* <span className="text">{option.text}</span> */}
                      {/* <span
  className="text"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {option.text}
</span> */}

<span
  className="text"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {option.text}
</span>
                    </button>
                      </div>
                  ))}
                </div>
                {/* <div className="lock-tip">Choices lock after selection</div> */}
                {/* <div
  className="lock-tip"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "14px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  Choices lock after selection
</div> */}

<div
  className="lock-tip"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  Choices lock after selection
</div>
              </div>
            </>
          )}
          </div>
        </div>
      </div>
    </GameContainer>
  );
};

// Confetti Canvas Component
const ConfettiCanvas: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    playTone("fanfare");
    setTimeout(() => playTone("complete"), 600);

    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles: any[] = [];
    const colors = [
      'rgba(54, 231, 255, 0.9)',
      'rgba(180, 107, 255, 0.9)',
      'rgba(255, 255, 255, 0.8)',
      'rgba(100, 255, 218, 0.9)',
    ];

    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    for (let i = 0; i < 120; i++) {
      const angle = (Math.PI * 2 * i) / 120 + Math.random() * 0.5;
      const speed = Math.random() * 8 + 4;
      particles.push({
        x: centerX,
        y: centerY,
        size: Math.random() * 6 + 3,
        color: colors[Math.floor(Math.random() * colors.length)],
        speedX: Math.cos(angle) * speed,
        speedY: Math.sin(angle) * speed,
        rotation: Math.random() * 360,
        rotationSpeed: Math.random() * 15 - 7.5,
        alpha: 1,
        decay: Math.random() * 0.015 + 0.008,
        type: Math.random() > 0.5 ? 'hex' : 'diamond'
      });
    }

    const drawHex = (x: number, y: number, size: number, rotation: number) => {
      ctx.beginPath();
      for (let i = 0; i < 6; i++) {
        const angle = (Math.PI / 3) * i + rotation;
        const px = x + size * Math.cos(angle);
        const py = y + size * Math.sin(angle);
        if (i === 0) ctx.moveTo(px, py);
        else ctx.lineTo(px, py);
      }
      ctx.closePath();
    };

    const drawDiamond = (x: number, y: number, size: number, rotation: number) => {
      ctx.beginPath();
      for (let i = 0; i < 4; i++) {
        const angle = (Math.PI / 2) * i + rotation;
        const px = x + size * Math.cos(angle);
        const py = y + size * Math.sin(angle);
        if (i === 0) ctx.moveTo(px, py);
        else ctx.lineTo(px, py);
      }
      ctx.closePath();
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach(p => {
        p.x += p.speedX;
        p.y += p.speedY;
        p.speedY += 0.15;
        p.speedX *= 0.99;
        p.rotation += p.rotationSpeed;
        p.alpha -= p.decay;

        if (p.alpha > 0) {
          ctx.save();
          ctx.globalAlpha = p.alpha;
          ctx.fillStyle = p.color;
          ctx.shadowBlur = 12;
          ctx.shadowColor = p.color;

          if (p.type === 'hex') {
            drawHex(p.x, p.y, p.size, p.rotation * Math.PI / 180);
          } else {
            drawDiamond(p.x, p.y, p.size, p.rotation * Math.PI / 180);
          }
          ctx.fill();
          ctx.restore();
        }
      });

      if (particles.some(p => p.alpha > 0)) {
        requestAnimationFrame(animate);
      }
    };
    animate();
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 9999
      }}
    />
  );
};

// Starfield Background
const StarfieldCanvas: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const starsRef = useRef<any[]>([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const DPR = Math.min(2, window.devicePixelRatio || 1);
    let W = 0, H = 0;

    const resize = () => {
      W = canvas.width = Math.floor(window.innerWidth * DPR);
      H = canvas.height = Math.floor(window.innerHeight * DPR);
      canvas.style.width = window.innerWidth + "px";
      canvas.style.height = window.innerHeight + "px";
      makeStars();
    };

    const makeStars = () => {
      starsRef.current = [];
      // Regular stars
      for (let i = 0; i < 120; i++) {
        starsRef.current.push({
          x: Math.random() * W,
          y: Math.random() * H,
          z: Math.random() * 1 + 0.2,
          r: Math.random() * 1.2 + 0.2,
          vx: (Math.random() * 0.25 + 0.05) * DPR,
          vy: 0,
          a: Math.random() * 0.6 + 0.2,
          isAmbient: false
        });
      }
      // Ambient particles
      for (let i = 0; i < 20; i++) {
        starsRef.current.push({
          x: Math.random() * W,
          y: Math.random() * H,
          z: 0.1,
          r: Math.random() * 3 + 2,
          vx: (Math.random() * 0.1 - 0.05) * DPR,
          vy: -(Math.random() * 0.3 + 0.15) * DPR,
          a: Math.random() * 0.12 + 0.04,
          isAmbient: true,
          color: Math.random() > 0.5 ? 'cyan' : 'violet',
          pulsePhase: Math.random() * Math.PI * 2,
          pulseSpeed: Math.random() * 0.02 + 0.01
        });
      }
    };

    const draw = () => {
      ctx.clearRect(0, 0, W, H);

      const g = ctx.createRadialGradient(W * 0.5, H * 0.5, 0, W * 0.5, H * 0.5, Math.max(W, H) * 0.55);
      g.addColorStop(0, "rgba(0,0,0,0)");
      g.addColorStop(1, "rgba(0,0,0,0.65)");
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, W, H);

      for (const s of starsRef.current) {
        if (s.isAmbient) {
          s.x += s.vx;
          s.y += s.vy;
          if (s.y < -20) { s.y = H + 20; s.x = Math.random() * W; }
          if (s.x < -20) s.x = W + 20;
          if (s.x > W + 20) s.x = -20;

          s.pulsePhase += s.pulseSpeed;
          const pulseAlpha = s.a * (0.6 + 0.4 * Math.sin(s.pulsePhase));
          const baseColor = s.color === 'cyan' ? '54,231,255' : '180,107,255';

          ctx.save();
          ctx.shadowBlur = 15;
          ctx.shadowColor = `rgba(${baseColor},${pulseAlpha * 2})`;
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r * DPR, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(${baseColor},${pulseAlpha})`;
          ctx.fill();
          ctx.restore();
        } else {
          s.x += s.vx * s.z;
          if (s.x > W + 20) { s.x = -20; s.y = Math.random() * H; }

          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r * DPR, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255,255,255,${s.a})`;
          ctx.fill();

          if (Math.random() < 0.015) {
            ctx.strokeStyle = `rgba(54,231,255,${s.a * 0.5})`;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(s.x, s.y);
            ctx.lineTo(s.x - 30 * DPR * s.z, s.y);
            ctx.stroke();
          }
        }
      }
      requestAnimationFrame(draw);
    };

    resize();
    window.addEventListener("resize", resize);
    draw();

    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      id="bg"
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        zIndex: 0
      }}
    />
  );
};

interface GameContainerProps {
  children: React.ReactNode;
  onComplete?: boolean;
}

const GameContainer: React.FC<GameContainerProps> = ({ children, onComplete }) => {
  return (
    <>
      <style>{gameStyles}</style>
      <div className="game-root">
        <StarfieldCanvas />
        <div className="scanlines"></div>
        <div className="wrap">
          {children}
        </div>
      </div>
    </>
  );
};


const gameStyles = `
  :root{
    --bg0:#05060a;
    --glass: rgba(255,255,255,.06);
    --glass2: rgba(255,255,255,.10);
    --stroke: rgba(255,255,255,.14);
    --text: rgba(255,255,255,.92);
    --muted: rgba(255,255,255,.70);
    --good: #4CFFB0;
    --bad:  #FF4C7B;
    --cyan: #36E7FF;
    --violet:#B46BFF;
    --gold: #FFD36B;
    --shadow: 0 20px 60px rgba(0,0,0,.55);
    --radius: 18px;
  }

  .game-root {
   
    color: var(--text);
    background: radial-gradient(1200px 800px at 20% 10%, rgba(180,107,255,.15), transparent 55%),
                radial-gradient(900px 700px at 80% 30%, rgba(54,231,255,.14), transparent 55%),
                radial-gradient(900px 700px at 50% 90%, rgba(255,211,107,.10), transparent 55%),
                var(--bg0);
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
    overflow-x: hidden;
  }

  .scanlines{
    pointer-events:none;
    position:fixed; inset:0;
    z-index:1;
    background: repeating-linear-gradient(
      to bottom,
      rgba(255,255,255,.03),
      rgba(255,255,255,.03) 1px,
      rgba(0,0,0,0) 3px,
      rgba(0,0,0,0) 6px
    );
    mix-blend-mode: overlay;
    opacity:.35;
    animation: scan 6s linear infinite;
  }
  @keyframes scan{
    from{transform:translateY(-10px)}
    to{transform:translateY(10px)}
  }

  // .wrap{
  //   position:relative;
  //   z-index:2;
 
  //   display:grid;
  //   place-items:center;
  //   padding:24px;
  //   width:min(94vw, 70rem);
  //   margin:0 auto;
  //   font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
  // }

  // .card{
  //   width:min(920px, 100%);
  
  //   border-radius: var(--radius);
  //   background: linear-gradient(180deg, var(--glass), rgba(255,255,255,.03));
  //   border:1px solid var(--stroke);
  //   box-shadow: var(--shadow);
  //   backdrop-filter: blur(14px);
  //   overflow:hidden;
  //   position:relative;
  //   display: flex;
  //   flex-direction: column;
  //   max-height:420px;
  // }

    .wrap{
      min-height:63vh;
      height:120px;
      position:relative;
      z-index:2;
       display: grid;      
      place-items:center;
      padding:24px;
      width:min(94vw, 70rem);
      // width:100%;
      max-height:85vh;
      overflow-y:auto;
      overflow-x:hidden;
      margin:0 auto;
      font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
    }

 @media (min-resolution: 1.25dppx) {
  .card {
    zoom: 0.92;
  }
}


//    .card {
//   width: fit-content;      /* 👈 key change */
//   max-width: 920px;        /* 👈 limit like your design */
//   min-width: 300px;        /* 👈 safety for small content */

//   margin: 0 auto;

//   border-radius: var(--radius);
//   background: linear-gradient(180deg, var(--glass), rgba(255,255,255,.03));
//   border: 1px solid var(--stroke);
//   box-shadow: var(--shadow);

//   backdrop-filter: blur(14px);
//   -webkit-backdrop-filter: blur(14px);

//   overflow: hidden;
//   position: relative;
//   display: flex;
//   flex-direction: column;

//   height: 385px;
//   padding: 1rem;
// }

   .card {
  // width: fit-content;      /* 👈 key change */
  // max-width: 920px;        /* 👈 limit like your design */
  // min-width: 300px;        /* 👈 safety for small content */

  width:100%;

  margin: 0 auto;

  border-radius: var(--radius);
  background: linear-gradient(180deg, var(--glass), rgba(255,255,255,.03));
  border: 1px solid var(--stroke);
  box-shadow: var(--shadow);

  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;

  height: 100%;
  padding: 1rem;
}

//   /* Scrollbar */
  .chat::-webkit-scrollbar { width: 10px; }
  .chat::-webkit-scrollbar-track { background: rgba(255,255,255,.05); border-radius: 4px; }
  .chat::-webkit-scrollbar-thumb { background: rgba(54,231,255,.35); border: 2px solid transparent; background-clip: padding-box; border-radius: 4px; }
  .chat::-webkit-scrollbar-thumb:hover { background: rgba(54,231,255,.5); }
  .chat { scrollbar-width: auto; scrollbar-color: rgba(54,231,255,.35) rgba(255,255,255,.05); }
  
.wrap::-webkit-scrollbar { width: 10px; }
  .wrap::-webkit-scrollbar-track { background: rgba(255,255,255,.05); border-radius: 4px; }
  .wrap::-webkit-scrollbar-thumb { background: rgba(54,231,255,.35); border: 2px solid transparent; background-clip: padding-box; border-radius: 4px; }
  .wrap::-webkit-scrollbar-thumb:hover { background: rgba(54,231,255,.5); }
  .wrap { scrollbar-width: auto; scrollbar-color: rgba(54,231,255,.35) rgba(255,255,255,.05); }


  .card::before{
    content:"";
    position:absolute; inset:0;
    background: radial-gradient(600px 220px at 20% 0%, rgba(54,231,255,.18), transparent 60%), radial-gradient(420px 200px at 80% 10%, rgba(180,107,255,.16), transparent 60%);
    opacity:.9;
    pointer-events:none;
  }

  .card::after{
    content:"";
    position:absolute;
    inset: -8px;
    background: radial-gradient(500px 300px at 50% 50%, rgba(54,231,255,.12), transparent 60%), radial-gradient(400px 250px at 30% 70%, rgba(180,107,255,.10), transparent 60%);
    filter: blur(12px);
    opacity: 0.18;
    pointer-events:none;
    z-index: -1;
    animation: cardAura 4s ease-in-out infinite alternate;
  }
  @keyframes cardAura {
    0% { opacity: 0.15; transform: scale(1); }
    100% { opacity: 0.22; transform: scale(1.02); }
  }

  .card > *{ position:relative; z-index:1; }

  /* Card animations */
  .pulse-good{ animation: goodPulse .35s ease-out 1; }
  @keyframes goodPulse{
    0%{ box-shadow: 0 0 0 rgba(76,255,176,0); transform: scale(1); }
    70%{ box-shadow: 0 0 24px rgba(76,255,176,.20); transform: scale(1.01); }
    100%{ box-shadow: 0 0 0 rgba(76,255,176,0); transform: scale(1); }
  }

  .shake-bad{ animation: badShake .25s ease-in-out 1; }
  @keyframes badShake{
    0%,100%{ transform: translateX(0); }
    20%{ transform: translateX(-6px); }
    40%{ transform: translateX(6px); }
    60%{ transform: translateX(-4px); }
    80%{ transform: translateX(4px); }
  }

  /* Spark burst effect */
  .spark{
    position:absolute;
    width:6px; height:6px;
    border-radius:50%;
    background: radial-gradient(circle at 30% 30%, rgba(255,255,255,.90), rgba(54,231,255,.55));
    box-shadow: 0 0 14px rgba(54,231,255,.25);
    opacity:0;
    transform: translate(-50%, -50%);
    animation: spark 520ms ease-out forwards;
    pointer-events:none;
    z-index:4;
  }
  @keyframes spark{
    0%{opacity:0; transform: translate(-50%, -50%) scale(.7)}
    18%{opacity:1}
    100%{opacity:0; transform: translate(calc(-50% + var(--dx)), calc(-50% + var(--dy))) scale(.25)}
  }

    .replay-btn{
    margin-top:12px; padding:14px 28px; font-size:15px; font-weight:600;
    background: linear-gradient(135deg, rgba(54,231,255,.15), rgba(180,107,255,.15));
    border:1px solid rgba(54,231,255,.5); border-radius:12px;
    color:var(--text); cursor:pointer; transition: all .2s ease;
    position: relative;
  z-index: 50;
   opacity: 1 !important;
  transform: none !important;
  }

  .topbar{
    display:flex;
    align-items:flex-start;
    justify-content:space-between;
    
    border-bottom:1px solid rgba(255,255,255,.10);
    flex-wrap: wrap;
    gap: 12px;
  }
  .title{display:flex; flex-direction:column; gap:2px;}
  .title h1{margin:0; font-size:16px; letter-spacing:.2px;}
  .title p{margin:0; font-size:12px; color:var(--muted); max-width:60ch;}

  .badge{
    display:inline-flex;
    align-items:center;
    gap:8px;
    padding:8px 10px;
    border-radius:12px;
    border:1px solid rgba(255,255,255,.12);
    background: rgba(0,0,0,.18);
    color:rgba(255,255,255,.86);
    font-size:12px;
  }
  .dot{
    width:8px; height:8px; border-radius:50%;
    background: radial-gradient(circle at 30% 30%, #fff, rgba(255,255,255,.2));
    box-shadow: 0 0 14px rgba(54,231,255,.55);
  }

  .pts{
    display:inline-flex;
    align-items:baseline;
    gap:6px;
    font-size:13px;
    color:rgba(255,255,255,.86);
  }
  .pts b{font-weight:700; color:rgba(255,255,255,.92)}

  .content{
    overflow-x:hidden;
    overflow-y:auto;
    height:100vh;
    display:flex;
    flex-direction:column;
    gap:12px;
   
    flex: 1;
    min-height: 0;
  }

  .chat-completion-enter{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px 24px;
    height: 100%;
    }

  .chat{
    border-radius:14px;
    border:1px solid rgba(255,255,255,.12);
    background: rgba(0,0,0,.18);
    padding:10px 12px;
    position:relative;
  }
  .chat::after{
    content:"";
    position:absolute;
    inset:-2px;
    background: linear-gradient(90deg, transparent, rgba(54,231,255,.10), transparent);
    transform: translateX(-60%);
    animation: shimmer 3.8s ease-in-out infinite;
    pointer-events:none;
  }
  @keyframes shimmer{
    0%{transform: translateX(-60%)}
    55%{transform: translateX(60%)}
    100%{transform: translateX(60%)}
  }

  .speaker
  {
  overflow-y:auto;
  display:flex;
  align-items:center; 
  justify-content:space-between;
  gap:8px;
  margin-bottom:6px; 
  color:rgba(255,255,255,.88);
  font-size:12px;
  }

  .speaker-info
  {

  display:flex; 
  align-items:center;
  gap:8px;
  }
  .avatar{
    width:28px; height:28px;
    border-radius:10px;
    background:
      radial-gradient(circle at 30% 20%, rgba(255,255,255,.35), rgba(255,255,255,0) 55%),
      linear-gradient(135deg, rgba(54,231,255,.24), rgba(180,107,255,.18));
    border:1px solid rgba(255,255,255,.18);
    box-shadow: 0 0 24px rgba(54,231,255,.15);
    animation: avatarGlow 3s ease-in-out infinite;
  }
  @keyframes avatarGlow {
    0%, 100% { box-shadow: 0 0 24px rgba(54,231,255,.15); }
    50% { box-shadow: 0 0 35px rgba(54,231,255,.4), 0 0 50px rgba(180,107,255,.25); }
  }
  .line{font-size:14px; font-weight: 400; line-height:1.35; margin:0 0 4px; color:rgba(255,255,255,.92);}
  .prompt{margin:0; font-size:12px; color:var(--muted);}

  .choices{
    border-radius:14px;
    border:1px solid rgba(255,255,255,.12);
    background: rgba(0,0,0,.14);
    padding:10px;
    display:flex;
    flex-direction:column;
    gap:8px;
    // min-height: 160px;
    flex: 1;
  }

  #choiceButtons{
    display:grid;
    gap:8px;
    flex: 1;
    min-height: 120px;
  }

  @media (max-width: 500px){
    #choiceButtons{
      grid-template-columns: 1fr !important;
      grid-template-rows: auto !important;
    }
  }

  .btn{
    width:100%;
    border:none;
    cursor:pointer;
    text-align:left;
    padding:12px 12px;
    border-radius:14px;
    color:rgba(255,255,255,.90);
    background: linear-gradient(180deg, rgba(255,255,255,.08), rgba(255,255,255,.03));
    border:1px solid rgba(255,255,255,.12);
    box-shadow: 0 12px 30px rgba(0,0,0,.22);
    transition: transform .12s ease, border-color .12s ease, background .12s ease, opacity .12s ease;
    position:relative;
    display:flex;
    flex-direction:column;
    justify-content:start;
    overflow:hidden;
  }
  .btn::before {
    content: "";
    position: absolute;
    inset: -2px;
    border-radius: 16px;
    background: linear-gradient(90deg, transparent, rgba(54,231,255,.4), transparent);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }
  .btn:hover:not(:disabled)::before {
    opacity: 1;
    animation: btnGlow 1.5s ease-in-out infinite;
  }
  @keyframes btnGlow {
    0%, 100% { transform: translateX(-100%); }
    50% { transform: translateX(100%); }
  }
  .btn:hover:not(:disabled){transform: translateY(-1px); border-color: rgba(54,231,255,.25);}
  .btn:active:not(:disabled){transform: translateY(0px) scale(.99)}
  .btn:disabled{cursor:not-allowed}
  .btn .label{display:inline-flex; align-items:center; gap:10px; font-size:13px; color:rgba(255,255,255,.70); margin-bottom:4px;}
  .chip{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    width:26px; height:22px;
    border-radius:10px;
    border:1px solid rgba(255,255,255,.16);
    background: rgba(0,0,0,.18);
    color:rgba(255,255,255,.85);
    font-size:12px;
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
  }
  .btn .text{
  display:block; 
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial; 
  letter-spacing:0.01em; 
  font-weight:400; 
  font-size:14px; 
  line-height:1.35; 
  color:rgba(255,255,255,.90);}

  .lock-tip {
    font-size: 11px;
    color: var(--muted);
    text-align: right;
    opacity: 0.7;
  }

  /* Timer ring */
  .timer-ring {
    position: relative;
    width: 38px;
    height: 38px;
    flex-shrink: 0;
  }
  .timer-ring svg {
    transform: rotate(-90deg);
    width: 100%;
    height: 100%;
  }
  .timer-ring.danger {
    animation: timerPulse 0.5s ease-in-out infinite;
  }
  @keyframes timerPulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.08); }
  }
  .timer-ring .timer-text {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: rgba(255,255,255,.9);
  }

  /* Feedback overlay */
  .fbOverlay{
    position:absolute;
    inset:0;
    display:none;
    place-items:center;
    z-index:6;
    background: rgba(0,0,0,.55);
    backdrop-filter: blur(10px);
    padding: 18px;
  }
  .fbOverlay.show{ display:grid; }

  .feedback{
    width:min(560px, 100%);
    border-radius:16px;
    border:1px solid rgba(255,255,255,.12);
    background: rgba(20,22,35,.92);
    padding:14px;
    box-shadow: 0 22px 80px rgba(0,0,0,.65);
    animation: pop .18s ease-out;
  }
  @keyframes pop{from{transform: scale(.98); opacity:0} to{transform: scale(1); opacity:1}}

  .feedback.good{border-color: rgba(76,255,176,.28);}
  .feedback.bad{border-color: rgba(255,76,123,.26);}

  .fb-head{display:flex; align-items:center; gap:12px; margin-bottom:6px;}
  .fb-head strong{font-size:13px; letter-spacing:.2px; color: #fff;}
  .fb-text{margin:0 0 8px; font-size:13px; color:rgba(255,255,255,.84); line-height:1.45;}
  .rewrite{margin:0; font-size:13px; color:rgba(255,255,255,.88); line-height:1.4; padding:10px; border-radius:12px; border:1px dashed rgba(255,255,255,.16); background: rgba(255,255,255,.04);}
  .rewrite b{color: rgba(255,255,255,.92)}

  .fbActions{
    display:flex;
    justify-content:flex-end;
    gap:10px;
    margin-top:12px;
  }
  .ghost{
    border:1px solid rgba(255,255,255,.16);
    background: rgba(255,255,255,.06);
    color: rgba(255,255,255,.86);
    padding:8px 14px;
    border-radius:12px;
    font-size:13px;
    cursor:pointer;
    transition: transform .12s ease;
  }
  .ghost:hover{ transform: translateY(-1px); }

  .primary{
    border:none;
    cursor:pointer;
    padding:10px 16px;
    border-radius:14px;
    background: linear-gradient(135deg, rgba(54,231,255,.25), rgba(180,107,255,.20));
    border:1px solid rgba(255,255,255,.16);
    color:rgba(255,255,255,.92);
    font-weight: 600;
    transition: transform .12s ease;
  }
  .primary:hover{transform: translateY(-1px);}

  /* Wipe transition */
  .wipe{
    position:absolute; inset:0;
    background: radial-gradient(700px 280px at 50% 50%, rgba(54,231,255,.10), rgba(0,0,0,.85));
    place-items:center;
    z-index:5;
    backdrop-filter: blur(10px);
  }
  .wipe .msg{
    text-align:center;
    padding:18px 18px;
    border-radius:16px;
    border:1px solid rgba(255,255,255,.14);
    background: rgba(0,0,0,.28);
    box-shadow: 0 20px 60px rgba(0,0,0,.55);
  }
  .bar{margin-top:12px; height:10px; border-radius:999px; background: rgba(255,255,255,.08); border:1px solid rgba(255,255,255,.12); overflow:hidden;}
  .bar > i{
    display:block;
    height:100%;
    width:40%;
    background: linear-gradient(90deg, rgba(255,255,255,.4), rgba(255,255,255,.6));
    border-radius:999px;
    animation: load 900ms ease-in-out infinite alternate;
  }
  @keyframes load{from{transform: translateX(-60%)} to{transform: translateX(140%)}}

  .completion-enter {
    animation: completionEnter 0.4s ease-out forwards;
    min-height: 420px;
  }
  @keyframes completionEnter {
    0% { opacity: 0; transform: scale(0.92); }
    100% { opacity: 1; transform: scale(1); }
  }

  .completion-enter::after {
    opacity: 0.25 !important;
    filter: blur(18px) !important;
  }

  .completion-enter .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  #bg {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
`;
export default WeHaveChooseMinigame;

